// Unpublished Work © 2020-2025 Deere & Company.

import {User} from '../state/struct/user/user';
import {
    REDIRECT_USER_TO_PROFILE_SCREEN,
    REDIRECT_USER_TO_SEARCH_SCREEN,
    SET_CONFIGURATION,
    SET_USER_DATA
} from '../action-list';

const setUserData = (state, action) => User.update(state, {
    $merge: action.user
});

const setWarningFlagOnSearchScreen = (state, action) => User.update(state, {
    isUserRedirectedToSearch: {
        $set: action.isUserRedirectedToSearch
    }
});

const setWarningFlagOnProfileScreen = (state, action) => User.update(state, {
    isUserRedirectedToProfile: {
        $set: action.isUserRedirectedToProfile
    }
});

export function userDataReducer(state = new User({}), action = {}) {
    const actionHandlers = {
        [SET_USER_DATA]: setUserData,
        [SET_CONFIGURATION]: setUserData,
        [REDIRECT_USER_TO_SEARCH_SCREEN]: setWarningFlagOnSearchScreen,
        [REDIRECT_USER_TO_PROFILE_SCREEN]: setWarningFlagOnProfileScreen
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
